export interface FormatNumberOptions {
  locale?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}

export function formatNumber(
  value: number | null | undefined,
  options: FormatNumberOptions = {}
): string {
  if (typeof value !== "number") return "";

  const {
    locale = "en-US",
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
  } = options;
  return value.toLocaleString(locale, {
    minimumFractionDigits,
    maximumFractionDigits,
  });
}

/**
 * Formats a balance value (number or null) with 2 decimal places
 * Returns "0.00" for null/undefined values
 */
export function formatBalance(amount: number | null | undefined): string {
  if (typeof amount !== "number") return "0.00";

  return formatNumber(amount, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
